<script setup>
import {onMounted, ref, onBeforeMount, inject, watchEffect, watch, computed} from "vue";
import Cookies from 'js-cookie';
import {useRouter} from "vue-router";
import {ElMessageBox, ElNotification} from 'element-plus';
import PersianDate from "persian-date";
import Swal from "sweetalert2";
import Crypto from'@/assets/crypto/crypto.json'
import { DocumentCopy} from '@element-plus/icons-vue'
import {CheckUser, fetchBitcoinBidPrice, fetchGBPtoUSDExchangeRate} from '@/assets/js/Help';
// import {useUserStore} from "@/store/userStore";
import termsText from '@/assets/terms.json';
import contractText from '@/assets/contract.json';
import {useStore} from "vuex";

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// const onPageDone = inject('reloadStore');
const router =useRouter();
const isLoading= ref(false);
const isWorking =ref(false);
const tabActive =ref(0);
const withdraw =ref(null);
const tableRef = ref(null);
const tableData = ref([]);
const currentPage =ref(1);
const allData=ref(null);
const methode = ref(1);
const deposit =ref(500000);
const perfectAmount =ref(15);
const fullUrl = ref('');
const crypto =ref(1);
const btcNetwork = ref(2);
const usdtNetwork = ref(1);
// const userStore = useUserStore();
// const {setUserData}=userStore
const perfectCode = ref('');
const perfectActCode = ref('');
const hashCode =ref('');
const projects = ref(null);
const SelectedProject = ref(null);
const Share = ref(1);
const BTCPrice =ref(0);
const USDPrice = ref(0);
const ShareValue = ref(0);
const terms =ref(false);
const contract =ref(false)
const IsTerms =ref(false)
const IsContract =ref(false);
const store = useStore();
const SelectedBank= ref(null);
const updateAdmin = (payload) => {
  store.dispatch("updateCurrAdmin", payload);
};
onBeforeMount(async () => {

});
const User = computed(() => store.state.currAdmin);
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
async function BTCPriceUpdate(){
 const btc =  await fetchBitcoinBidPrice();
 BTCPrice.value = ((parseFloat(SelectedProject.value?.ProjectValue)/100)*Share.value)/btc;
  BTCPrice.value=BTCPrice.value.toFixed(7);
  ShareValue.value=(parseFloat(SelectedProject.value?.ProjectValue)/100)*Share.value;
}
async function USDPriceUpdate(){
  const usd =  await fetchGBPtoUSDExchangeRate();
  USDPrice.value = ((SelectedProject.value?.ProjectValue/100)*Share.value)*usd;
  USDPrice.value=USDPrice.value.toFixed(7);
  ShareValue.value=(SelectedProject.value?.ProjectValue/100)*Share.value
}
onBeforeMount(async ()=>{
  if(!Cookies.get('user_token')){
    // await router.push('/sign')
  }
});
watchEffect(async ()=>{
  if(allData.value?.user ){
    // allData.value.user = userStore.$state.userData;
  }
})
watch(Share, async (newValue, oldValue) => {
  if(crypto.value===1){
    await BTCPriceUpdate();
  }
  if(crypto.value===2){
    await USDPriceUpdate();
  }
});
watch(crypto, async (newValue, oldValue) => {
  if(crypto.value===1){
    await BTCPriceUpdate();
  }
  if(crypto.value===2){
    await USDPriceUpdate();
  }
});
watch(SelectedProject, async (newValue, oldValue) => {
  if(crypto.value===1){
    await BTCPriceUpdate();
  }
  if(crypto.value===2){
    await USDPriceUpdate();
  }
});
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
onMounted(async ()=>{
  const data = await CheckUser(router);
  await updateAdmin(data)
  await getData();
  fullUrl.value = window.location.href
  // onPageDone();
})
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
async function getData(newpage){
  if(!User.value?.Id){
    return
  }
  if(newpage){
    currentPage.value=newpage;
  }
  const response = await fetch('https://inv.tvcnews.co/endPoint/getProjects2.php',{
    method:"POST",
    headers:{
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization':'Bearer '+ decodeURIComponent(Cookies.get('user_token'))
    },
    body:JSON.stringify({page:currentPage.value,userId:User.value?.Id})
  })
  const data = await response.json();
  console.log(data)
  switch (data.status){
    case 200:
      projects.value = data?.data?.project
        tableData.value= data?.data?.transactions?.records
      isLoading.value=false
      break;
    default:
      ElNotification({
        title: 'Error '+data.status,
        message: data.message,
        type: 'error'
      })
      // router.push('/')
      break;
  }
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function validateInput() {
  // Allow only numbers and remove leading zeros
  withdraw.value = withdraw.value.replace(/^-1+|[^0-9]/g, '')
  withdraw.value = withdraw.value.replace(/^0+/, '')

  // If the value is an empty string, set it to 1
  if (withdraw.value === '') {
    withdraw.value = '0'
  }
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function persianDate(dateString) {
  const date = new Date(dateString);
  const persianDate = new PersianDate(date);
  return persianDate.format("D MMMM YYYY  HH:mm");
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function typePayment(text){
  let obj ={
    name:'',
    type:''
  }
  switch (text){
    case'ShareProfit':
      obj.name='واریز سود سهام';
      obj.type='success';
      break;
    case'Buy':
      obj.name='خرید سهام';
      obj.type='info';
      break;
    case'Withdraw':
      obj.name='درخواست تسویه';
      obj.type='warning';
      break;
    case'Withdraw-Done':
      obj.name='تسویه موفق';
      obj.type='primary';
      break;
    case'Deposit':
      obj.name='واریز';
      obj.type='success';
      break;
  }
  return obj;
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
async function pageChange(newpage){
  isWorking.value=true;
  await getData(newpage);
  isWorking.value=false;
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
async function withdrawNow(){
  if(!withdraw.value||withdraw.value===0){
    await ElMessageBox.confirm(
        'مبلغ مورد نظر جهت برداشت را انتخاب کنید',
        'خطا',
        {
          confirmButtonText: 'باشه',
          type: 'warning',
          center: true,
          buttonSize:'large',
          showCancelButton:false,
          customStyle:'font-family:"dirooz";direction:rtl'
        }
    )
    return
  }
  if(!User.value.BankDetails[SelectedBank.value]){
    await ElMessageBox.confirm(
        'مقصد تسویه خود را مشخص کنید',
        'خطا',
        {
          confirmButtonText: 'باشه',
          type: 'warning',
          center: true,
          buttonSize:'large',
          showCancelButton:false,
          customStyle:'font-family:"dirooz";direction:rtl'
        })
  }
  isWorking.value=true;
  const response = await fetch('https://inv.tvcnews.co/endPoint/withdraw.php',{
    method:"POST",
    headers:{
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization':'Bearer '+ decodeURIComponent(Cookies.get('user_token'))
    },
    body:JSON.stringify({price:withdraw.value,bank:User.value.BankDetails[SelectedBank.value]})
  })
  const data = await response.json();
  let data1=null;
  console.log(data)
  switch (data.status){
    case 200:
      withdraw.value='';
      isLoading.value=false;
      isWorking.value=false;
      await ElMessageBox.confirm(
          'درخواست تسویه شما با موفقیت ثبت شد طی سه روز کاری آینده مبلغ مربوطه به حساب بانکی ثبت شده شما انتقال می یابد',
          'برداشت موفق',
          {
            confirmButtonText: 'باشه',
            type: 'success',
            center: true,
            buttonSize:'large',
            showCancelButton:false,
            customStyle:'font-family:"dirooz";direction:rtl;text-align:right'
          }
      )
      data1 = await CheckUser(router);
      await updateAdmin(data1)
      await getData();
      // onPageDone();
      break;
    case 398:
      await ElMessageBox.confirm(
          'مجوز دسترسی به سیستم دریافت نشده است',
          'خطا',
          {
            confirmButtonText: 'باشه',
            type: 'warning',
            center: true,
            buttonSize:'large',
            showCancelButton:false,
            customStyle:'font-family:"dirooz";direction:rtl'
          }
      )
      break;
    case 399:
      await ElMessageBox.confirm(
          'مجوز دسترسی فاقد اعتبار می باشد',
          'خطا',
          {
            confirmButtonText: 'باشه',
            type: 'warning',
            center: true,
            buttonSize:'large',
            showCancelButton:false,
            customStyle:'font-family:"dirooz";direction:rtl'
          }
      )
      break;

    case 401:
      await ElMessageBox.confirm(
          'حساب کاربری شما یافت نشد دوباره وارد حساب کاربری شوید',
          'خطا',
          {
            confirmButtonText: 'باشه',
            type: 'warning',
            center: true,
            buttonSize:'large',
            showCancelButton:false,
            customStyle:'font-family:"dirooz";direction:rtl'
          }
      )
      break;
    case 402:
      await ElMessageBox.confirm(
          'حساب کاربری شما مسدود می باشد',
          'خطا',
          {
            confirmButtonText: 'باشه',
            type: 'warning',
            center: true,
            buttonSize:'large',
            showCancelButton:false,
            customStyle:'font-family:"dirooz";direction:rtl'
          }
      )
      break;
    case 403:
      await ElMessageBox.confirm(
          'مشکلی در ثبت درخواست شما وجود دارد',
          'خطا',
          {
            confirmButtonText: 'باشه',
            type: 'warning',
            center: true,
            buttonSize:'large',
            showCancelButton:false,
            customStyle:'font-family:"dirooz";direction:rtl'
          }
      )

      break;
    case 404:
      await ElMessageBox.confirm(
          'حداقل مبلغ قابل برداشت 10 پوند می باشد',
          'خطا',
          {
            confirmButtonText: 'باشه',
            type: 'warning',
            center: true,
            buttonSize:'large',
            showCancelButton:false,
            customStyle:'font-family:"dirooz";direction:rtl'
          }
      )
      break;
    case 405:
      await ElMessageBox.confirm(
          'موجودی حساب شما کافی نیست',
          'خطا',
          {
            confirmButtonText: 'باشه',
            type: 'warning',
            center: true,
            buttonSize:'large',
            showCancelButton:false,
            customStyle:'font-family:"dirooz";direction:rtl'
          }
      )

      break;
    case 406:
     await ElMessageBox.confirm(
          'حساب کاربری شما تایید نشده است',
          'خطا',
          {
            confirmButtonText: 'OK',
            type: 'warning',
            center: true,
          }
      )
      break;
    default:
      ElNotification({
        title: 'Error '+data.status,
        message: data.message,
        type: 'error'
      })
      // await router.push('/')
      break;
  }

  isWorking.value=false;
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const copyToClipboard = async (textToCopy) => {
  try {
    await navigator.clipboard.writeText(textToCopy);
    ElNotification({
      title: 'کیف پول',
      message: "آدرس کیف پول با موفقیت کپی شد",
      type: 'success'
    })
  } catch (err) {
    ElNotification({
      title: 'کیف پول',
      message: "آدرس کیف پول کپی نشد",
      type: 'error'
    })
  }
};

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
async function CheckHash(type){
  if(!hashCode.value){
    ElNotification({
      title:"خطای Hash" ,
      message: "لطفا هش تراکنش را وارد کنید و دوباره تلاش کنید",
      type: 'error'
    })
    return
  }
  const response = await fetch('https://inv.tvcnews.co/endPoint/Crypto.php',{
    method:"POST",
    headers:{
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization':'Bearer '+ decodeURIComponent(Cookies.get('user_token'))
    },
    body:JSON.stringify({
      Hash:hashCode.value,
      Type:type,
      Pid:SelectedProject.value
    })
  })
  const data = await response.json();
  console.log(data)
  switch (data.status){
    case 200:
      ElNotification({
        title: "پرداخت موفق",
        message: "پرداخت شما با موفقیت ثبت شد. مدارک و قراردادهای شما از طریق ایمیل برای شما ارسال خواهد شد.",
        type: 'success'
      })
        hashCode.value='';
      await getData(1)
      break;
    case 403:
      ElNotification({
        title: "پرداخت نا موفق",
        message: "مبلغ ارز دیجیتال انتقال داده شده کمتر از حداقل میزان خرید سهام بوده است. لطفا جهت  پیگیری ارز دیحیتال منتقل شده با پشتیبانی و چت آنلاین تماس بگیرید",
        type: 'warning',
        style:'font-family:tahoma'
      })
      break;
    case 402:
      ElNotification({
        title: "پرداخت ناموفق",
        message: "قبلا با این Hash تراکنش خرید شده است لطفا Hash تراکنش تکراری وارد نفرمایید.",
        type: 'error',
        style:'font-family:tahoma;direction:rtl;text-align:right'
      })
      break;
    case 401:
      ElNotification({
        title: "پرداخت نا موفق",
        message: "هَش تراکنش ارائه شده فاقد اعتبار است یا هنوز به مرحله تایید نرسیده است در صورتی که از هش اطمینان دارید پس از تایید تراکنش دوباره امتحان کنید",
        type: 'error',
        style:'font-family:tahoma;text-align:right'
      })
      break;
    default:
      ElNotification({
        title: 'Error '+data.status,
        message: data.message,
        type: 'error',
        style:'font-family:tahoma;text-align:right'
      })
      break;
  }
  perfectCode.value=''
  perfectActCode.value='';
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Reactive variable for error message
const errorMessage = ref('');
const validateShare = () => {
  const min = parseFloat(SelectedProject.value?.MinShare) || 0.5;
  const max = parseFloat(SelectedProject.value?.MaxShare) || 49;

  if (Share.value < min) {
    errorMessage.value = `حداقل سهمی که می توانید خریداری کنید  ${min} سهم می باشد.`;
    Share.value = min;
  } else if (Share.value > max) {
    errorMessage.value = `حداکثر سهام موجود ${max} سهم می باشد.`;
    Share.value = max;
  } else {
    errorMessage.value = ''; // Clear the error message if valid
  }
};

const getLabel = (item) => {
  if (item.type === "حساب بانکی ایران") {
    return `${item.BankName} ${item.Iban}`;
  } else if (item.type === "حساب بانکی خارج از ایران") {
    return `${item.BankName} ${item.Iban}`;
  } else if (item.type === "کیف پول ارز دیجیتال") {
    return `${item.Token} ${item.WalletAddress} ${item.WalletNetwork}`;
  }
  return "Unknown";
};
</script>

<template>
  <el-dialog v-model="IsTerms" title="شرایط و قوانین استفاده از وبسایت" width="800" style="font-family: 'dirooz';">
      <div v-html="termsText?.terms1" style="direction: rtl;text-align: right;font-family: 'dirooz'"></div>
  </el-dialog>
  <el-dialog v-model="IsContract" title="قرارداد سرمایه گذاری" width="800" style="font-family: 'dirooz'">
    <div v-html="contractText?.contract" style="direction: rtl;text-align: right;font-family: 'dirooz'"></div>
  </el-dialog>
  <div class="card" style="font-family: 'dirooz'">
    <div class="tabs">
      <div @click="tabActive=0" class="tab_left " :class="{active:tabActive ===0}">
        خرید سهام
      </div>
      <div @click="tabActive=1" class="tab_right" :class="{active:tabActive ===1}">
        برداشت سود سهام
      </div>
    </div>
    <div v-show="tabActive ===0" class="tab_container charge">
      <div class="btn-group">
        <el-button-group class="ml-4">
<!--          <el-button @click="methode=1" class="btn" :type="methode===1?'info':'warning'" >ارز دیجیتال (بیت کوین، تتر)</el-button>-->
<!--          <el-button @click="methode=2" class="btn" :type="methode===2?'info':'danger'" >پرفکت مانی</el-button>-->
<!--          <el-button @click="methode=3" class="btn" :type="methode===3?'info':'primary'" >کارت های بانکی ایران</el-button>-->
        </el-button-group>
      </div>
      <div v-if="methode===1" class="iranian-card">
        <label>انتخاب پروژه سرمایه گذاری</label>
        <el-select
            v-model="SelectedProject"
            placeholder="انتخاب پروژه"
            size="large"
            style="width: 100%;direction: rtl;text-align: right"
            @change="projectOnChange"
        >
          <el-option
              v-for="item in projects"
              :key="item?.ProjectId"
              :label="item.ProjectName+' - Available Shares: '+item.SharesAvailable+' %'"
              :value="item"
          />
        </el-select>

        <div v-if="SelectedProject">
          <label>میزان سهام خود را انتخاب کنید</label>
          <el-input
              v-model="Share"
              size="large"
              type="number"
              :max="parseFloat(SelectedProject?.MaxShare)"
              :min="parseFloat(SelectedProject?.MinShare)"
              @input="validateShare"
              :class="{ 'error-border': errorMessage }"
          />
          <p style="text-align: right;direction: rtl" v-if="errorMessage" class="error-message">{{ errorMessage }}</p>

        </div>
        <div style="text-align: center;margin-top: 10px;margin-bottom: 20px" v-if="SelectedProject">
          <el-radio-group v-model="crypto">
            <el-radio :label="1" size="large" border>BTC</el-radio>
            <el-radio :label="2" size="large" border>USDT</el-radio>
          </el-radio-group>
          <div v-if="crypto===2" style="display: flex;flex-flow: wrap;flex-direction: row;align-items: center;justify-content: center;">
            <h1 v-if="crypto===2">{{USDPrice}}</h1>
            <span>USDT</span>
          </div>
        <div v-if="crypto===1" style="display: flex;flex-flow: wrap;flex-direction: row;align-items: center;justify-content: center;">
          <h1 v-if="crypto===1">{{BTCPrice}}</h1>
          <span>BTC</span>
        </div>
          <p>£ {{ShareValue}}</p>
        </div>
<div v-if="SelectedProject">
        <div v-if="crypto===1">
          <label >انتخاب نوع شبکه</label><br>
          <el-radio-group v-model="btcNetwork">
            <!--            <el-radio :label="1">Ethereum (ERC20)</el-radio>-->
            <el-radio :label="2">Bitcoin</el-radio>
          </el-radio-group>
          <p class="textNote">لطفاً آدرس کیف پول را برای انتقال استفاده کنید و به شبکه انتقال و هزینه‌های آن توجه کنید. هزینه انتقال بر عهده شماست و مبلغی که به دست ما می‌رسد باید دقیقاً معادل عدد ذکرشده باشد.</p>

          <div v-if="btcNetwork===2">
            <img loading="lazy" style="width: 150px;margin-top: 10px" alt="iran lotto payment" src="../assets/crypto/BTC-Bitcoin.jpg">
            <div class="mt-4">
              <el-input
                  v-model="Crypto.BTC.BITCOIN.code"
                  placeholder="Please input"
                  class="input-with-select"
                  disabled
              >
                <template #append>
                  <el-button @click="copyToClipboard(Crypto.BTC.BITCOIN.code)" style="color: blue;" :icon="DocumentCopy" />
                </template>
              </el-input>
            </div>
            <p class="textNote">در هنگام انتقال ارز دیجیتال به نوع شبکه انتقال دقت کنید که در هنگام ارسال شبکه یکسان را انتخاب کنید</p>
            <div style="direction: rtl;text-align: center">
              <label >
                کد هش Hash تراکنش خود را وارد کنید و دکمه بررسی را بزنید.در صورت تکمیل شدن تراکنش حساب کاربری شما شارژ می شود
              </label>
            </div>
            <el-input input-style="width:100%;text-align:center" v-model="hashCode"  size="large"  type="text"   placeholder="کد هَش (Hash) تراکنش ارز دیجیتال" />
            <a @click="IsTerms=true" style="cursor: pointer;color: #0078ff">شرایط و قوانین سایت</a><br><el-checkbox v-model="terms" style="direction: rtl;"  label="- شرایط و قوانین سایت و کمپانی را مطالعه کردم و آن را می پذیرم" size="large" /><br>
            <a @click="IsContract=true" style="cursor: pointer;color: #0078ff">قرارداد سرمایه گذاری</a><br><el-checkbox v-model="contract" style="direction: rtl;" label="- قرارداد و شرایط سرمایه گذاری را مطالعه کردم و آن را می پذیرم و امضا می کنم" size="large" /><br>
            <br>
            <el-button style="margin-top: 10px"  @click="CheckHash('BTC')" type="primary" >بررسی تراکنش و شارژ حساب کاربری</el-button>
          </div>
          <!--          <div v-if="btcNetwork===1">-->
          <!--            <img loading="lazy" style="width: 150px;margin-top: 10px" alt="iran lotto payment" src="../../../assets/crypto/BTC-ERC20.webp">-->
          <!--            <div class="mt-4">-->
          <!--              <el-input-->
          <!--                  v-model="Crypto.BTC.ERC20.code"-->
          <!--                  placeholder="Please input"-->
          <!--                  class="input-with-select"-->
          <!--                  disabled-->
          <!--              >-->
          <!--                <template #append>-->
          <!--                  <el-button @click="copyToClipboard(Crypto.BTC.ERC20.code)" style="color: blue;" :icon="DocumentCopy" />-->
          <!--                </template>-->
          <!--              </el-input>-->
          <!--            </div>-->
          <!--            <p class="textNote">در هنگام انتقال ارز دیجیتال به نوع شبکه انتقال دقت کنید که در هنگام ارسال شبکه یکسان را انتخاب کنید</p>-->

          <!--          </div>-->
        </div>
        <div v-if="crypto===2">
          <label >انتخاب نوع شبکه</label><br>
          <el-radio-group v-model="usdtNetwork">
            <el-radio :label="1">Ethereum (ERC20)</el-radio>
            <el-radio :label="2">Tron TRC20</el-radio>
          </el-radio-group>
          <p class="textNote">لطفاً آدرس کیف پول را برای انتقال استفاده کنید و به شبکه انتقال و هزینه‌های آن توجه کنید. هزینه انتقال بر عهده شماست و مبلغی که به دست ما می‌رسد باید دقیقاً معادل عدد ذکرشده باشد.</p>

          <div v-if="usdtNetwork===1">
            <img loading="lazy" style="width: 150px;margin-top: 10px" alt="iran lotto payment" src="../assets/crypto/USDT-ERC20.jpg">
            <div class="mt-4">
              <el-input
                  v-model="Crypto.USDT.ERC20.code"
                  placeholder="Please input"
                  class="input-with-select"
                  disabled
              >
                <template #append>
                  <el-button @click="copyToClipboard(Crypto.USDT.ERC20.code)" style="color: blue;" :icon="DocumentCopy" />
                </template>
              </el-input>
            </div>
            <p class="textNote">در هنگام انتقال ارز دیجیتال به نوع شبکه انتقال دقت کنید که در هنگام ارسال شبکه یکسان را انتخاب کنید</p>
            <div style="direction: rtl;text-align: center">
              <label >
                کد هش Hash تراکنش خود را وارد کنید و دکمه بررسی را بزنید.در صورت تکمیل شدن تراکنش حساب کاربری شما شارژ می شود
              </label>
            </div>
            <el-input input-style="width:100%;text-align:center" v-model="hashCode"  size="large"  type="text"   placeholder="کد هَش (Hash) تراکنش ارز دیجیتال" />
            <a @click="IsTerms=true" style="cursor: pointer;color: #0078ff">شرایط و قوانین سایت</a><br><el-checkbox v-model="terms" label="شرایط و قوانین سایت و کمپانی را مطالعه کردم و آن را می پذیرم" size="large" /><br>
            <a @click="IsContract=true" style="cursor: pointer;color: #0078ff">قرارداد سرمایه گذاری</a><br><el-checkbox v-model="contract" label="قرارداد و شرایط سرمایه گذاری را مطالعه کردم و آن را می پذیرم و امضا می کنم" size="large" /><br>
            <br>
            <el-button style="margin-top: 10px"  @click="CheckHash('Ether')" size="large" type="primary" >بررسی تراکنش و خرید سهام</el-button>
          </div>
          <div v-if="usdtNetwork===2">
            <img loading="lazy" style="width: 150px;margin-top: 10px" alt="iran lotto payment" src="../assets/crypto/USDT-Tron.jpg">
            <div class="mt-4">
              <el-input
                  v-model="Crypto.USDT.TRC20.code"
                  placeholder="Please input"
                  class="input-with-select"
                  disabled
              >
                <template #append>
                  <el-button @click="copyToClipboard(Crypto.USDT.TRC20.code)" style="color: blue;" :icon="DocumentCopy" />
                </template>
              </el-input>
            </div>
            <p class="textNote">لطفاً آدرس کیف پول را برای انتقال استفاده کنید و به شبکه انتقال و هزینه‌های آن توجه کنید. هزینه انتقال بر عهده شماست و مبلغی که به دست ما می‌رسد باید دقیقاً معادل عدد ذکرشده باشد.</p>
            <div style="direction: rtl;text-align: center">
              <label >
                کد هش Hash تراکنش خود را وارد کنید و دکمه بررسی را بزنید.در صورت تکمیل شدن تراکنش حساب کاربری شما شارژ می شود
              </label>
            </div>
            <el-input input-style="width:100%;text-align:center" v-model="hashCode"  size="large"  type="text"   placeholder="کد هَش (Hash) تراکنش ارز دیجیتال" />
            <el-button style="margin-top: 10px"  @click="CheckHash('Tron')" type="primary" >بررسی تراکنش و خرید</el-button>
          </div>
        </div>
</div>
      </div>

    </div>
    <div v-show="tabActive ===1" class="tab_container flex-container">
      <div class="col-8">
        <h4 style="font-weight: bold;font-family: 'dirooz'">در این بخش می‌توانید درخواست برداشت سود سهام خود را ثبت کنید.

        </h4>
        <p style="text-align: justify;font-family: 'dirooz'">
          برای برداشت سود سهام، مبلغ درخواست‌شده طی ۷۲ ساعت کاری به حساب بانکی ثبت‌شده شما واریز می‌شود. لطفاً مطمئن شوید که اطلاعات بانکی خود را با دقت در بخش پروفایل وارد کرده‌اید. مبلغ سود به نرخ ارز روزی که درخواست برداشت ثبت شده است محاسبه خواهد شد. توجه داشته باشید که هرگونه اشتباه در وارد کردن اطلاعات بانکی ممکن است باعث تأخیر در واریز شود.        </p>
      </div>
      <div class="col-4 cardLabel" style="text-align: center;background-color: aliceblue;">
        <p style=";font-family: 'dirooz'">موجودی حساب کاربری</p>
        <h5 style="margin-top: 15px;font-family: 'dirooz'">{{ parseInt(User?.Balance).toLocaleString() }} پوند</h5>
        <h6 style="margin-top: 20px;font-family: 'dirooz'">مبلغ برداشت</h6>
        <el-input input-style="text-align:center;font-family: 'dirooz'" @input="validateInput"  type="currency" size="large" v-model="withdraw" placeholder=" مبلغ " />
        <label style="text-align:center;font-family: 'dirooz'">مقصد تسویه حساب</label>
        <el-select
            v-model="SelectedBank"
            placeholder="انتخاب حساب بانکی یا کیف پول دیجیتال"
            size="large"
            style="width: 100%;text-align: right;direction: rtl;"
        >
          <el-option
              v-for="(item,index) in User?.BankDetails"
              :key="index"
              :label="getLabel(item)"
              :value="index"
              style="font-family: Tahoma"
          />
        </el-select>
        <small>اگر هنوز اطلاعات بانکی یا کیف پول خود را وارد نکردید به بخش پروفایل مراجعه فرمایید.</small>
        <el-button @click="withdrawNow()" style="margin-top: 20px;font-family: 'dirooz'" type="primary" :loading="isWorking">برداشت</el-button>
      </div>
    </div>
    <hr class="line">
    <div class="table_container">
        <el-table ref="tableRef" row-key="date" :data="tableData" style="width: 100%;font-family: 'dirooz'">
          <el-table-column prop="ToomanPayments" label="مبلغ-تومان">
            <template #default="scope">
              <p style="direction: rtl;word-break: normal;">
                {{parseInt(scope.row.SecondAmount).toLocaleString() +' تومان'}}
              </p>
              <p v-if="isMobileDevice()" style="direction: rtl;word-break: normal;font-size: 10px;color: #9f9b9b">
                {{Math.round(scope.row.Amount).toLocaleString() +' '+ scope.row.Currency}}
              </p>
            </template>
          </el-table-column>

          <el-table-column v-if="!isMobileDevice()" prop="Amount" label="مبلغ"  >
            <template #default="scope">
              <p style="direction: rtl;word-break: normal;">
                {{Math.round(scope.row.Amount).toLocaleString() +' '+ scope.row.Currency}}
              </p>
            </template>
          </el-table-column>
          <el-table-column  prop="tag" label="نوع تراکنش">
            <template #default="scope">
              <el-tag :type="typePayment(scope.row.PayType).type"  disable-transitions>
                {{ typePayment(scope.row.PayType).name }}

              </el-tag>
              <p v-if="isMobileDevice()" style="direction: rtl;word-break: normal;font-size: 10px;color: #9f9b9b">
                {{persianDate(scope.row.CreateOn)}}
              </p>
            </template>
          </el-table-column>
          <el-table-column v-if="!isMobileDevice()"  prop="CreatOn" label="تاریخ" sortable  column-key="date" >
            <template #default="scope">
              <p  style="direction: rtl;word-break: normal">
                {{persianDate(scope.row.CreateOn)}}
              </p>
            </template>

          </el-table-column>
          <el-table-column v-if="!isMobileDevice()" prop="Id" label="کد تراکنش"  />
        </el-table>

      <div v-if="tableData?.length!==0" class="pagei">
        <el-pagination small @current-change="pageChange"  v-model="currentPage" background layout="prev, pager, next" :total="allData?.total" :page-size="10"/>
      </div>
    </div>
  </div>
</template>
<style scoped>
.error-border input {
  border: 2px solid red !important;
}

.error-message {
  color: red;
  font-size: 0.875em;
  margin-top: 4px;
}
.mt-4{
  max-width: 60%;
  margin-right: auto;
  margin-left: auto;
}
.payBtn{
  width: 100px;
  height: 35px;
  background-color: #009aff;
  color: #fff;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}
.payBtn:active{
  background-color: #00d0ff;
  color: #3c4250;
}
.textNote{
  font-size: 14px;
  background-color: antiquewhite;
  border-radius: 5px;
  padding: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
  direction: rtl;
}
.textBox{
  direction: rtl;
  background-color: aquamarine;
  margin-top: 10px;
  border-radius: 5px;
  padding: 10px;
}
.cf{
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
.perfectBtn{
  background: transparent;
  border: none;
  height: fit-content;
  width: fit-content;
  border-radius: 10px;
  margin-top: 10px;
}
.perfectBtn img{
  border-radius: 10px;
  box-shadow: 0 0 12px -4px rgba(0,0,0,0.75);
}
.iranian-card{
  direction: ltr;
  text-align: center;
  width: 98%;
  min-height: 150px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
}
.btn-group{
  width: 98%;
}
.charge{
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: space-between;
  align-items: center;
}

.pagei{

  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.table_container{
  direction: ltr;
  text-align: right;
  text-align-last: right;

}

.line{
  border: none;
  margin-top: 10px;
  height: 1px;
  width: 100%;
  margin-bottom: 10px;
  background-color: #bbbbbb;
}
.cardLabel{
  text-align: center;
  border: solid 1px #c7c4c4;
  padding: 10px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  border-radius: 5px;
}
.flex-container{
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: space-between;
  align-items: center;
}
.col-4{
  width: 31%;
}
.col-8{
  width: 63%;
}
.tab_container{
  padding: 15px;
  direction: rtl;
  border-top: solid 1px #82b0bf;
}
.tabs{
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
  cursor: pointer;
}
.tab_left{
  width: 50%;
  text-align: center;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.tab_right{
  width: 50%;
  text-align: center;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}
.active{
  box-shadow: inset 0 0 5px 0 rgba(0,0,0,0.45);
  background-color: lightblue;
  font-weight: 600;
  transition: background-color 0.2s , box-shadow 0.2s ease;
}
.card{
  margin: 20px;
  padding: 15px;
  border: solid 1px #d1d1d1;
  border-radius: 10px;
  direction: ltr;
}
.el-tabs__nav-scroll{
  float: right;
}
@media only screen and (min-width: 1200px) and (max-width:1500px){

}
@media only screen and (min-width: 768px) and (max-width:1199px) {
  .btn{
    width: 100%;
    margin-top: 5px;
  }
}
@media only screen and (min-width: 421px) and (max-width: 767px) {
  .col-8{
    width: 98%;
  }
  .col-4{
    width: 98%;
  }
  .btn{
    width: 100%;
    margin-top: 5px;
  }
  .mt-4{
    max-width: 100%;
    margin-right: auto;
    margin-left: auto;

  }
}
@media only screen and (max-width: 420px) {
  .col-8{
    width: 98%;
  }
  .col-4{
    width: 98%;
  }
  .btn{
    width: 100%;
    margin-top: 5px;
  }
  .iranian-card{
    width: 98%;
  }
  .btn-group{
    width: 98%;
  }
  .mt-4{
    max-width: 100%;
    margin-right: auto;
    margin-left: auto;

  }
}
.swal2-custom-text {
  font-family: 'dirooz'!important;
}
.swal2-title {
  font-family: 'dirooz', sans-serif !important;
}
.swal2-html-container {
  font-family: 'dirooz', sans-serif !important;
}
</style>